import Container from 'react-bootstrap/Container';
import { determineTenant } from '../utils/tenants';
import { getUserTenants } from '../utils/Permissions';
import { TermsAndConditionsContentInvestCEO } from '../docs/terms/investceo/latest';
import { TermsAndConditionsContentALM } from '../docs/terms/alm/latest';
import { TermsAndConditionsContentOptionGenius } from '../docs/terms/optiongenius/latest';
import { PrivacyPolicyContentALM } from '../docs/privacy/alm/latest';

const TENANT_TERMS = {
    investceo: { label: 'InvestCEO', component: TermsAndConditionsContentInvestCEO },
    optiongenius: { label: 'Option Genius', component: TermsAndConditionsContentOptionGenius },
    alm: { label: 'ALM Trading', component: TermsAndConditionsContentALM },
};

export const TermsPage = () => {
    const userTenants = getUserTenants();
    // If logged in with tenants, show all their tenant T&Cs; otherwise fall back to URL-based tenant
    const tenants = userTenants.length > 0 ? userTenants : [determineTenant()];

    return (
        <Container className="py-4" style={{ maxWidth: '900px' }}>
            {tenants.map((tenant) => {
                const entry = TENANT_TERMS[tenant] || TENANT_TERMS.alm;
                const TermsContent = entry.component;
                return (
                    <div key={tenant} className={tenants.length > 1 ? 'mb-5 pb-4 border-bottom' : ''}>
                        {tenants.length > 1 && (
                            <h4 className="text-muted mb-3">{entry.label}</h4>
                        )}
                        <TermsContent />
                    </div>
                );
            })}
        </Container>
    );
};

export const PrivacyPage = () => (
    <Container className="py-4" style={{ maxWidth: '900px' }}>
        <h2 className="mb-4">Privacy Policy</h2>
        <PrivacyPolicyContentALM />
    </Container>
);
